export enum RaceClass{
    "TOP_FUEL" = "Top Fuel",
    "FUNNY_CAR" = "Funny Car",
    "PRO_STOCK" = "Pro Stock",
    "PRO_STOCK_MOTORCYCLE" = "Pro Stock Motorcycle",
    "PRO_MOD" = "Pro Mod",
    "TOP_FUEL_TOP_MOMENTS" = "Top Fuel - Top Moments",
    "FUNNY_CAR_TOP_MOMENTS" = "Funny Car - Top Moments",
    "PRO_STOCK_TOP_MOMENTS" = "Pro Stock - Top Moments",
    "PRO_STOCK_MOTORCYCLE_TOP_MOMENTS" = "Pro Stock Motorcycle - Top Moments",
    "OVERALL_TOP_MOMENTS" = "NHRA - Top Moments",
}

export function raceClassFromInt(raceClass: number): RaceClass {
    switch (raceClass) {
        case 1:
            return RaceClass.TOP_FUEL;
        case 2:
            return RaceClass.FUNNY_CAR;
        case 3:
            return RaceClass.PRO_STOCK;
        case 4:
            return RaceClass.PRO_STOCK_MOTORCYCLE;
        case 5:
            return RaceClass.PRO_MOD;
        case 6:
            return RaceClass.TOP_FUEL_TOP_MOMENTS;
        case 7:
            return RaceClass.FUNNY_CAR_TOP_MOMENTS;
        case 8:
            return RaceClass.PRO_STOCK_TOP_MOMENTS;
        case 9:
            return RaceClass.PRO_STOCK_MOTORCYCLE_TOP_MOMENTS;
        case 10:
            return RaceClass.OVERALL_TOP_MOMENTS;
        default:
            return RaceClass.TOP_FUEL;
    }
}

export function raceClassToInt(raceClass: RaceClass): number {
    switch (raceClass) {
        case RaceClass.TOP_FUEL:
            return 1;
        case RaceClass.FUNNY_CAR:
            return 2;
        case RaceClass.PRO_STOCK:
            return 3;
        case RaceClass.PRO_STOCK_MOTORCYCLE:
            return 4;
        case RaceClass.PRO_MOD:
            return 5;
        case RaceClass.TOP_FUEL_TOP_MOMENTS:
            return 6;
        case RaceClass.FUNNY_CAR_TOP_MOMENTS:
            return 7;
        case RaceClass.PRO_STOCK_TOP_MOMENTS:
            return 8;
        case RaceClass.PRO_STOCK_MOTORCYCLE_TOP_MOMENTS:
            return 9;
        case RaceClass.OVERALL_TOP_MOMENTS:
            return 10;
        default:
            return 1;
    }
}

export function raceClassFromString(raceClass: string): RaceClass {
    switch (raceClass) {
        case "Top Fuel":
            return RaceClass.TOP_FUEL;
        case "Funny Car":
            return RaceClass.FUNNY_CAR;
        case "Pro Stock":
            return RaceClass.PRO_STOCK;
        case "Pro Stock Motorcycle":
            return RaceClass.PRO_STOCK_MOTORCYCLE;
        case "Pro Mod":
            return RaceClass.PRO_MOD;
        case "Top Fuel - Top Moments":
            return RaceClass.TOP_FUEL_TOP_MOMENTS;
        case "Funny Car - Top Moments":
            return RaceClass.FUNNY_CAR_TOP_MOMENTS;
        case "Pro Stock - Top Moments":
            return RaceClass.PRO_STOCK_TOP_MOMENTS;
        case "Pro Stock Motorcycle - Top Moments":
            return RaceClass.PRO_STOCK_MOTORCYCLE_TOP_MOMENTS;
        case "NHRA - Top Moments":
            return RaceClass.OVERALL_TOP_MOMENTS;
        default:
            return RaceClass.TOP_FUEL;
    }
}

export function isTopMomentsRaceClass(raceClass: RaceClass): boolean {
    return raceClass === RaceClass.TOP_FUEL_TOP_MOMENTS ||
           raceClass === RaceClass.FUNNY_CAR_TOP_MOMENTS ||
           raceClass === RaceClass.PRO_STOCK_TOP_MOMENTS ||
           raceClass === RaceClass.PRO_STOCK_MOTORCYCLE_TOP_MOMENTS ||
           raceClass === RaceClass.OVERALL_TOP_MOMENTS;
}